import { makeStyles, Grid, Box, Typography } from "@material-ui/core";

import { DialogBox } from "../../components/boxes";
import { Icon, Dialog, Button } from "../../components/base";
import SuccessIcon from "../../assets/images/icons/success-icon.svg";
import { COLORS } from "../../theme/colors";
import doneAnimation from "../../assets/JSON/done.json";
import JsonAnimation from "../../components/base/JsonAnimation";

const useStyles = makeStyles(() => ({
  root: {
    width: 520,
    height: 386,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    backgroundColor: COLORS.lightGreen,
  },
  typography: {
    maxWidth: "95%",
    textAlign: "center",
    marginTop: 10,
  },
  successMsg: {
    fontSize: 18,
    color: COLORS.darks[0][100],
    marginBottom: 10,
  },
  buttonContainer: {
    marginTop: 40,
  },
}));

export const Success = ({
  isOpen,
  setOpen,
  subMsg,
  successMsg,
  src,
  height,
  width,
  subMsgStyle,
  successMsgStyle,
  rootStyle,
}) => {
  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog isOpen={isOpen} onClose={() => setOpen(false)}>
      <DialogBox>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
          className={rootStyle ? rootStyle : classes.root}
        >
          <Box className={classes.icon}>
            {src === "done" ? (
              <JsonAnimation height={160} width={160} loop={false} animationData={doneAnimation} />
            ) : (
              <Icon src={src ? src : SuccessIcon} height={height} width={width} />
            )}
          </Box>
          <Box className={classes.typography}>
            <Typography
              variant="h6"
              className={successMsgStyle ? successMsgStyle : classes.successMsg}
            >
              {successMsg}
            </Typography>
          </Box>
          <Box className={classes.typography}>
            <Typography variant="h6" className={subMsgStyle ? subMsgStyle : classes.successMsg}>
              {subMsg}
            </Typography>
          </Box>
          {successMsgStyle && (
            <Box className={classes.buttonContainer}>
              <Button text="CLOSE" onClick={() => handleClose()} />
            </Box>
          )}
        </Grid>
      </DialogBox>
    </Dialog>
  );
};
